import { render, staticRenderFns } from "./CarrierPhoto.vue?vue&type=template&id=512f9b80&scoped=true"
import script from "./CarrierPhoto.vue?vue&type=script&lang=js"
export * from "./CarrierPhoto.vue?vue&type=script&lang=js"
import style0 from "./CarrierPhoto.vue?vue&type=style&index=0&id=512f9b80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512f9b80",
  null
  
)

export default component.exports